import { generateVideoUrl as i, parseUrl as s } from "../../helpers/video-url-parser.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
import { defineAttrs as n } from "../../utils/typed-attrs.js";
const d = n({
  type: { default: "video" },
  provider: {
    default: "youtube"
  },
  id: { default: "" }
}), l = {
  inline: !1,
  attrs: d,
  group: "block",
  parseDOM: [
    {
      tag: "iframe",
      getAttrs(e) {
        const { provider: t, id: r } = s(e.src);
        return { provider: t, id: r };
      }
    }
  ],
  toDOM(e) {
    const t = e.attrs, r = i(t.provider, t.id);
    return [
      "div",
      {
        class: `${o.blockContainer} ${o.video}`
      },
      [
        "iframe",
        {
          src: r,
          style: "pointer-events: none;"
        }
      ]
    ];
  }
};
export {
  l as videoSpec
};
